const quickLinks = [
  { label: "首页", href: "#home" },
  { label: "萌系推荐", href: "#featured" },
  { label: "治愈清单", href: "#healing" },
  { label: "作品亮点", href: "#spotlight" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

const tagLinks = [
  "软萌画风作品",
  "治愈系漫画清单",
  "温馨剧情漫画",
  "可爱角色合集",
  "萌系日常漫画",
];

export default function Footer() {
  return (
    <footer className="bg-primary-700 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-primary-700">
                <i className="ri-footprint-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">
                皮皮喵漫画
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/90">
              皮皮喵漫画聚合萌系推荐与治愈系漫画清单，软萌画风、温馨剧情、可爱角色一网打尽。
              日常更新治愈向作品，助你快速定位心仪的软萌佳作，追更不迷路。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="inline-flex items-center gap-1.5 text-sm text-background-100/90 transition-colors hover:text-background-50"
                  >
                    <i className="ri-arrow-right-s-line text-xs"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50">热门标签</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {tagLinks.map((tag) => (
                <a
                  key={tag}
                  href="#featured"
                  className="whitespace-nowrap rounded-full bg-primary-600 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-500"
                >
                  {tag}
                </a>
              ))}
            </div>
            <p className="mt-5 text-sm text-background-100/80">
              投稿与合作：hello@pipimiao.example.com
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-primary-600 pt-6 sm:flex-row">
          <p className="text-sm text-background-100/80">
            © {new Date().getFullYear()} 皮皮喵漫画 · 治愈系漫画清单与萌系推荐
          </p>
          <div className="flex items-center gap-4 text-sm text-background-100/80">
            <a href="#home" className="transition-colors hover:text-background-50">
              回到顶部
            </a>
            <a href="#contact" className="transition-colors hover:text-background-50">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}